import React from 'react';
import Header from '../components/Header';
import { Play } from 'lucide-react';

const Portfolio = () => {
  const videos = [
    { id: "NH51G258gTg", thumbnail: "https://i.ytimg.com/vi_webp/NH51G258gTg/sddefault.webp" },
    { id: "3lNyXEgfiPM", thumbnail: "https://i.ytimg.com/vi_webp/3lNyXEgfiPM/sddefault.webp" },
    { id: "CvcsiQEtd-Q", thumbnail: "https://i.ytimg.com/vi_webp/CvcsiQEtd-Q/sddefault.webp" },
    { id: "jIRnbOJONdg", thumbnail: "https://i.ytimg.com/vi_webp/jIRnbOJONdg/sddefault.webp" }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />

      {/* Portfolio Section */}
      <section className="pt-32 pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold mb-4 text-center" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Portfolio
          </h1>
          <p className="text-xl text-white/70 mb-16 text-center max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Explore our work and see how we've helped brands capture attention and drive growth through video-led content.
          </p>

          {/* Video Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
            {videos.map((video, idx) => (
              <a 
                key={idx}
                href={`https://youtube.com/watch?v=${video.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="relative group overflow-hidden rounded-xl aspect-video bg-white/5 hover:bg-white/10 transition-all duration-300"
              >
                <img 
                  src={video.thumbnail} 
                  alt={`Video ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Play className="text-black ml-1" size={28} fill="currentColor" />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative py-16 sm:py-24 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://framerusercontent.com/images/mCmSpcpcYCZJTSJSoearkxxG0FQ.png?width=236&height=240" 
                  alt="AttentionLabs" 
                  className="h-10 w-10"
                />
                <span className="text-white font-bold text-xl" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  AttentionLabs
                </span>
              </div>
              <p className="text-white/70 text-sm mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
                811, Tower C, Unitech Business Zone<br />
                Sector 50, Gurugram, India
              </p>
            </div>

            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Links</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/#clients" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Clients</a></li>
                <li><a href="/#portfolio" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Portfolio</a></li>
                <li><a href="/#why-choose-us" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Why Choose Us</a></li>
                <li><a href="/#how-we-operate" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>How We Operate</a></li>
                <li><a href="/#testimonials" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Testimonials</a></li>
                <li><a href="/#faqs" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>FAQs</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Pages</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Home</a></li>
                <li><a href="/portfolio" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Portfolio</a></li>
                <li><a href="/casestudies" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Case Studies</a></li>
                <li><a href="/contact" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Contact</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Socials</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="https://www.instagram.com/attention.labs/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>Instagram</a></li>
                <li><a href="https://www.youtube.com/@AttentionLabs-br" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>YouTube</a></li>
                <li><a href="https://www.linkedin.com/company/attentionlabscom/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" style={{ fontFamily: 'Inter, sans-serif' }}>LinkedIn</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 text-center">
            <p className="text-white/50 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              Visioned and Crafted by AttentionLabs © All rights reserved
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Portfolio;
